import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  TEACHERS_STUDENTS_DETAIL,
  TEACHERS_STUDENT_PORTFOLIO_URL
} from 'config/urls';
import { cutText } from 'utils';

import ProgressBar from 'pages/Teachers/StudentListV2/components/ProgressBar';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';
import { reverse } from 'utils/urls';
import { stringifyParams } from 'utils/urls';

import UserContext from 'components/UserContext';

import styles from './styles.module.scss';

const STUDENT_DETAIL_VIEW_ENABLED =
  process.env.REACT_APP_STUDENT_DETAIL_VIEW_ENABLED === 'true';

const StudentRow = ({ student, currentPage }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const user = useContext(UserContext);

  const toggleRow = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  // TODO: drop sectionLabel and studentId and extract them from the url after the redirect.
  const handleRowClick = ({ event, sectionId }) => {
    event.stopPropagation();
    if (STUDENT_DETAIL_VIEW_ENABLED) {
      trackMixpanelEvent(user.id, 'User selects a student', {
        feature: 'students',
        view: 'list',
        button: 'student',
        class_id: sectionId
      });
      history.push({
        pathname: reverse(TEACHERS_STUDENTS_DETAIL, {
          studentId: student.id,
          sectionId
        }),
        search: stringifyParams({
          page: currentPage
        })
      });
    } else {
      history.push({
        pathname: reverse(TEACHERS_STUDENT_PORTFOLIO_URL, { id: student.id }),
        state: { from: location }
      });
    }
  };

  return (
    <>
      <tr
        className={styles.mainRow}
        onClick={(e) =>
          student.sections.length === 0
            ? handleRowClick({
                event: e,
                sectionId: student.section_id
              })
            : toggleRow(e)
        }
      >
        <td>{cutText({ text: student.name, char: 30 })}</td>
        <td>
          {student.sections.length > 0 ? (
            <button className={styles.expandButton} onClick={toggleRow}>
              {cutText({ text: student.section_label, char: 30 })}
              <span
                className={isExpanded ? styles.chevronUp : styles.chevronDown}
              >
                ▼
              </span>
            </button>
          ) : (
            <span className={styles.sectionText}>
              {cutText({ text: student.section_label, char: 30 })}
            </span>
          )}
        </td>
        <td className={styles.lightText}>{student.recent_upload}</td>
        <td>
          <ProgressBar
            student={student}
            averagePercentage={student.average_percentage}
            goalInformation={student.goal_information}
            averageTargetAccuracy={student.average_target_accuracy}
          />
        </td>
      </tr>

      {student.sections.length > 0 &&
        isExpanded &&
        student.sections?.map((section) => (
          <tr
            key={section.id}
            className={styles.subRow}
            onClick={(e) =>
              handleRowClick({
                event: e,
                sectionId: section.id
              })
            }
          >
            <td></td>
            <td className={styles.lightText}>{section.name}</td>
            <td className={styles.lightText}>{section.recent_upload}</td>
            <td>
              <ProgressBar
                student={student}
                averagePercentage={section.average_percentage}
                goalInformation={section.goal_information}
                isSubRow={true}
                handleRowClick={(e) =>
                  handleRowClick({
                    event: e,
                    sectionId: section.id
                  })
                }
                averageTargetAccuracy={section.average_target_accuracy}
              />
            </td>
          </tr>
        ))}
    </>
  );
};

export default StudentRow;
